<script>
	/**
	 * 詳細画面パーツ.<br>
	 * メモ.<br>
	 * @module js\common\trEdit.mixin.vue
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_settings - 初期設定値
	 * @param {string[]} r_class - CSSのクラス名
	 * @param {string[]} r_is_require - 必須入力か
	 * @param {string[]} r_is_edit -変更があるかないか
	 **/
export default {
	props:{
		'r_settings': {},
		'r_class': {
			type:String,
			default: ""
		},
		'r_is_require':{
			type:Boolean,
			default:false
		},
		'r_disabled':{
			type:Boolean,
			default:false
		}
	},
	data: function () {
		return{
			m_isChange: false,		// 変更されたかチェックフラグ
			m_isNotInput: false,	// 入力データがあるかないかチェックフラグ
			m_isEdit: false,		// 編集されたデータかチェックフラグ
			m_isChangeSelect: false,	// 選択リストが変更されたかチェックフラグ
			m_isChangeText: false,		// テキストが変更されたかチェックフラグ
			m_isCodeChange: false,	// コードが直接入力されたかチェックフラグ
		}
	},
	computed:{
	},
	methods: {
		/**
		* 編集可能箇所のCSSclassを取得する <br>
		* ******* 内部処理 *******<br>
		* フラグを変更する。 <br>
		*
		* @function createEditClassType
		* @param {} 
		* @instance
		**/
		createEditClassType: function(val, isChange = this.m_isChange){
			var className = this.r_class + " ";
			if( this.r_is_require && val === "" ) {
				// 必須項目で未入力の場合 
				className += this.REQUIRED_EMPTY_COL;
				this.m_isNotInput = true;
			} else if ( isChange ) {
				// 編集中
				className += this.UPDATING_COL;
				this.m_isNotInput = false;
			}
			return className;
		},
		/**
		* 編集可能箇所のCSSclassを取得する <br>
		* ******* 内部処理 *******<br>
		* フラグを変更する。 <br>
		*
		* @function createEditClassType
		* @param {} 
		* @instance
		**/
		createEditClassTypeSelect: function(val, isChange = this.m_isChangeSelect){
			var className = this.r_class + " ";
			if( this.r_is_require && val === "" ) {
				// 必須項目で未入力の場合 
				className += this.REQUIRED_EMPTY_COL;
				this.m_isNotInput = true;
			} else if ( isChange ) {
				// 編集中
				className += this.UPDATING_COL;
				this.m_isNotInput = false;
			}
			return className;
		},
		/**
		* 編集可能箇所のCSSclassを取得する <br>
		* ******* 内部処理 *******<br>
		* フラグを変更する。 <br>
		*
		* @function createEditClassType
		* @param {} 
		* @instance
		**/
		createEditClassTypeText: function(val, isChange = this.m_isChangeText){
			var className = this.r_class + " ";
			if( this.r_is_require && val === "" ) {
				// 必須項目で未入力の場合 
				className += this.REQUIRED_EMPTY_COL;
				this.m_isNotInput = true;
			} else if ( isChange ) {
				// 編集中
				className += this.UPDATING_COL;
				this.m_isNotInput = false;
			}
			return className;
		},
		/**
		 * 変更フラグを変更 <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function  setUpdate
		 * @param {bool} is - 変更フラグ
		 * @instance
		 */
		setUpdate: function( is ){
			this.m_isChange = is;
			this.m_isChangeSelect = is;
			this.m_isChangeText = is;
			this.m_isCodeChange = is;
		},
		/**
		 * 変更されたデータかチェック <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function  checkUpdate
		 * @instance
		 */
		checkUpdate: function(){
			// 編集権限なしの場合は変更なしとする
			if ( !this.r_settings.edit_right ) {
				return false;
			}
			// 必須項目
			if (this.r_is_require) {
				// return !this.m_isNotInput&&this.m_isChange?true:false;
				if (this.$parent.r_is_new != undefined) {
					// 既存
					if (!this.$parent.r_is_new) {
						return (this.m_isChange) ? true : false;
					}
				}
				return (!this.m_isNotInput && this.m_isChange) ? true : false;
			}
			return this.m_isChange;
		},
		/**
		 * 編集フラグを変更 <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function  setIsEdit
		 * @param {bool} is - 変更フラグ
		 * @instance
		 */
		setIsEdit: function( is ){
			this.m_isEdit = is;
		},
		/**
		* キーアップイベント <br>
		* ******* 内部処理 *******<br>
		*
		* @function onKeyup
		* @param {object} e - イベントオブジェクト
		* @instance
		*/
		onKeyup: function( e ){
			this.$emit('keyup', e);
		},
		/**
		* フォーカスアウトイベント <br>
		* ******* 内部処理 *******<br>
		*
		* @function onKeyup
		* @param {object} e - イベントオブジェクト
		* @instance
		*/
		onBlur: function(e) {
			this.$emit('blur', e);
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/trEdit.mixin.vue